import React, { useState } from "react";
import Axios from "axios";
import { AiFillQuestionCircle, AiOutlineClose } from "react-icons/ai";
import { Modal } from "antd";
import "./InstructionButton.css";
import { VscZoomIn, VscZoomOut } from "react-icons/vsc";
import { IconIMUMRulesImageModal } from "../Layout/Icons.jsx";
import InstructionBlocks from "./InstructionBlocks.jsx";
import Spinner from "../common/Spinner";

const RuleCard = ({ title, children, onModalChange, image }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [zoom, setZoom] = useState(0.5);
  const maxZoom = 2;
  const minZoom = 0.5;

  const showModal = () => {
    setIsModalVisible(true);
    onModalChange(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    handleDownload();
    onModalChange(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    onModalChange(false);
  };

  const handleZoomIn = () => {
    if (zoom < maxZoom) {
      setZoom((prevZoom) => prevZoom * 2);
    }
  };

  const handleZoomOut = () => {
    if (zoom > minZoom) {
      setZoom((prevZoom) => prevZoom / 2);
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = image;
    link.download = title;
    link.click();
  };

  return (
    <>
      <div className="itemContainer">
        <div className="ruleCardItemContainer d-flex flex-row align-items-center">
          <p className="ruleCardTitle">{title}</p>
          {image && (
            <div
              onClick={() => {
                !isModalVisible ? showModal() : handleCancel();
              }}
            >
              <IconIMUMRulesImageModal className="iconImageModal ml-1" />
            </div>
          )}
        </div>
        <div style={{ padding: 10 }}>{children}</div>
      </div>
      <Modal
        title={title}
        open={isModalVisible}
        onOk={handleOk}
        width={600}
        okText="Parsisiųsti"
        onCancel={handleCancel}
        className="imageModal"
      >
        <div>
          <div className="d-flex justify-content-end">
            <div className="mr-1" onClick={handleZoomIn}>
              <VscZoomIn className="cursor-pointer" size={18} color="#8C8C8C" />
            </div>
            <div onClick={handleZoomOut}>
              <VscZoomOut
                className="cursor-pointer"
                size={18}
                color="#8C8C8C"
              />
            </div>
          </div>
          <div className="ruleCardOverflowAuto">
            <img
              src={image}
              alt="Rule"
              className="ruleCardRuleImage"
              style={{ width: `${zoom * 100}%` }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

const InstructionButton = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isImageModalShowing, setIsImageModalShowing] = useState(false);
  const [sections, setSections] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleModalChange = (isShowing) => {
    setIsImageModalShowing(isShowing);
  };

  const fetchSections = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await Axios.get("/api/v1/instructions/imum");
      setSections(data?.sections || []);
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const onOpen = () => {
    setShowModal(true);
    if (!sections && !loading) fetchSections();
  };

  return (
    <div className="buttonContainer">
      <button className="helpButton" onClick={onOpen}>
        <AiFillQuestionCircle color="#FFFFFF" size={17} />
      </button>

      {showModal && (
        <>
          {!isImageModalShowing && (
            <div
              className="modalBackground"
              onClick={() => setShowModal(false)}
            />
          )}

          <div className="modalContainer">
            <div className="modalContent" onClick={(e) => e.stopPropagation()}>
              <div className="modalHeader">
                <div className="modalTitle">
                  <AiFillQuestionCircle color="#42ADE2" size={20} />
                  <p className="modalTitleText">Pagalba</p>
                </div>
                <AiOutlineClose
                  color="#00000080"
                  cursor="pointer"
                  onClick={() => setShowModal(false)}
                />
              </div>
              <div className="modalInnerContainer">
                {loading && (
                  <div className="py-4">
                    <Spinner full={false} />
                  </div>
                )}
                {error && (
                  <p className="p-3">
                    Nepavyko užkrauti pagalbos informacijos. Bandykite dar
                    kartą.
                  </p>
                )}
                {!loading &&
                  !error &&
                  (sections || []).map((section) => (
                    <RuleCard
                      key={section.key || section.title}
                      title={section.title}
                      onModalChange={handleModalChange}
                      image={section.image}
                    >
                      <InstructionBlocks blocks={section.blocks} />
                    </RuleCard>
                  ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InstructionButton;
